import React, { useState } from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "Components/ReactstrapSlim";
import classes from "./ActivityHeader.module.scss";
import { useActivity } from "../hooks";
import { ActivitiesType } from "../contexts";
import exhaustiveCheck from "Utils/exhaustiveCheck";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import DateFilter from "../MapSection/DateFilter";
interface ActivityHeaderProps {
   className?: string;
}

const getFilterLabel = (filter: ActivitiesType) => {
   switch (filter) {
      case ActivitiesType.ALL:
         return "All Activity";
      case ActivitiesType.FOLLOWING:
         return "Following"; 
      case ActivitiesType.MY:
         return "My Activity";
      default:
         exhaustiveCheck(filter);
         return "";
   }
}

const ActivityHeader: React.FC<ActivityHeaderProps> = ({ className }) => {
   const [open, setOpen] = useState(false);
   const toggleOpen = () => setOpen((o) => !o);
   const { countryCodes, filter, setFilter } = useActivity();
   const showDateFilter = useMediaBreakpointDown("md");
   const removeStateFilter = () => {
      setFilter({
         state: undefined
      });
   }

   const getStateName = (country: string, state: string) => {
      const stateCodes = countryCodes.find(cc => cc.value == country)?.stateCodes;
      if(stateCodes)
      {
         const result = stateCodes.find(sc => sc.value == state);
         if(result)
            return result.text;
      }
      return state;
   }
   const handleChangeType = (type: ActivitiesType) => {
      setFilter({ type });
   };
   return (
      <div className={classNames(classes.container, className)}>
         {filter.state ? <>
            <div className={classes.stateHeader}>
               <Button size="icon" color="transparent" onClick={removeStateFilter}>
                  <Icons.ArrowLeftAlt />
               </Button>
               <div className="h6">
                  {getStateName("US", filter.state)} Activity
               </div>
            </div>
         </>
            : <>
               <div className="h6">
                  Activity
               </div>
               <div className={classes.filters}>
                  {showDateFilter && <DateFilter className={classes.dateFilter} />}
                  <Dropdown isOpen={open} toggle={toggleOpen}>
                     <DropdownToggle caret color="transparent" size="sm" >
                        {getFilterLabel(filter.type)}
                     </DropdownToggle>
                     <DropdownMenu right className={classes.menu}>
                        {[ActivitiesType.ALL, ActivitiesType.FOLLOWING, ActivitiesType.MY].map(f => <DropdownItem key={f} onClick={(e) => handleChangeType(f)}>{getFilterLabel(f)}</DropdownItem>)}
                     </DropdownMenu>
                  </Dropdown>
               </div>
            </>}
      </div>
   );
};

export default ActivityHeader;
